module.exports = __webpack_public_path__ + "img/plan-img.7020d2bb.png";